import React from 'react';

const EffectiveDepositsSumPercent = () => {
    return (
        <div>

        </div>
    )
}

export default EffectiveDepositsSumPercent;